import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, TableCell, TableRow, Typography } from "@mui/material";
import React from "react";
import { LegislationSocialSecurityCostSectionRef } from "../../../../models/legislation-social-security-cost/legislation-social-security-cost-section-ref";

interface Props {
  ssSection: LegislationSocialSecurityCostSectionRef;
}

const SocialSecurityCostConfigurationRow = ({ ssSection }: Props) => {
  return (
    <TableRow>
      <TableCell>{ssSection.section?.name}</TableCell>
      <TableCell align="center">{ssSection.rate > 0 ? ssSection.rate : ""}</TableCell>
      <TableCell align="right">{ssSection.fixedAmount > 0 ? ssSection.fixedAmount.toLocaleCustom() : ""}</TableCell>
      <TableCell align="right">
        <Grid>
          <Typography variant="body2">
            {ssSection.capAmount > 0 ? (
              <span title={"Cap amount"}>
                <FontAwesomeIcon icon={faCaretUp} />
                {ssSection.capAmount.toLocaleCustom()}
              </span>
            ) : (
              ""
            )}
          </Typography>
          <Typography variant="body2">
            {ssSection.minAmount > 0 ? (
              <span title={"Minimum amount"}>
                <FontAwesomeIcon icon={faCaretDown} />
                {ssSection.minAmount.toLocaleCustom()}
              </span>
            ) : (
              ""
            )}
          </Typography>
        </Grid>
      </TableCell>
      <TableCell align="right">
        <Grid>
          <Typography variant="body2">
            {ssSection.dividedBy > 0 ? <span title={"Divided by"}>/{ssSection.dividedBy.toLocaleCustom()}</span> : ""}
          </Typography>
          <Typography variant="body2">
            {ssSection.multipliedBy > 0 ? (
              <span title={"Muliplied by"}>*{ssSection.multipliedBy.toLocaleCustom()}</span>
            ) : (
              ""
            )}
          </Typography>
        </Grid>
      </TableCell>
    </TableRow>
  );
};
export default SocialSecurityCostConfigurationRow;
